import React from 'react';

const VietnamAILaw = () => (
  <article className="news-article-body">
    <p className="news-lead">
      Vietnam became the first Southeast Asian country to pass a dedicated AI law when
      the National Assembly ratified the Law on Technology and Digital Innovation in
      November 2024. Effective January 2025, it covers AI development, deployment, and
      governance across both public and private sectors. For a country that's moved
      aggressively on digital transformation, it's a sign that Vietnam is serious about
      shaping AI development on its own terms.
    </p>

    <h2>What the law actually covers</h2>
    <p>
      The law establishes a framework across several areas:
    </p>
    <ul>
      <li>
        <strong>AI classification by risk:</strong> High-risk AI applications (medical diagnosis,
        hiring decisions, credit scoring, law enforcement) face stricter requirements including
        mandatory human review and explainability standards
      </li>
      <li>
        <strong>AI system registration:</strong> Commercial AI systems must be registered with
        the Ministry of Science and Technology before deployment
      </li>
      <li>
        <strong>Data localisation:</strong> AI systems processing Vietnamese citizens' data
        must store that data within Vietnam's borders
      </li>
      <li>
        <strong>Transparency requirements:</strong> Users must be informed when they're
        interacting with an AI system rather than a human
      </li>
      <li>
        <strong>Liability framework:</strong> Establishes who's responsible when AI systems
        cause harm - developers, deployers, or operators
      </li>
    </ul>

    <h2>The economic context</h2>
    <p>
      Vietnam has been one of the faster-growing tech economies in Southeast Asia, with a
      large software outsourcing sector and growing domestic tech companies. FPT Software,
      Viettel, and VNG have all made significant AI investments.
    </p>
    <p>
      The AI law is partly protective (ensuring Vietnamese citizens have rights vis-à-vis
      AI systems) and partly an enablement framework - giving domestic companies legal
      certainty to build and deploy AI commercially.
    </p>

    <h2>Challenges ahead</h2>
    <p>
      Implementation is the hard part. Registering and auditing AI systems at scale requires
      technical expertise most government agencies don't yet have. The Ministry of Science
      and Technology has acknowledged a capacity gap and has been working with universities
      and international technical assistance programs to build that expertise.
    </p>
    <p>
      The data localisation requirement is already creating friction for foreign AI service
      providers. Companies like Google and Microsoft face a choice between building local
      data infrastructure or limiting services to Vietnamese users.
    </p>

    <h2>Regional influence</h2>
    <p>
      Vietnam's law has been watched closely by other ASEAN countries still developing their
      AI governance approaches. The Philippines and Indonesia have both cited Vietnam's risk
      classification framework in their own draft regulations. Being first to legislate - even
      imperfectly - gives Vietnam's approach disproportionate regional influence.
    </p>

    <div className="news-insight-box">
      <h3>The big lesson</h3>
      <p>
        Vietnam's AI law demonstrates that developing countries don't have to wait for the
        EU or US to set the standard. By moving first in Southeast Asia, Vietnam has positioned
        itself to influence regional norms while giving its own tech sector a clear operating
        environment. The quality of implementation over the next few years will determine
        whether that turns out to be an advantage or a competitive burden.
      </p>
    </div>
  </article>
);

export default VietnamAILaw;
